module.exports = __webpack_public_path__ + "media/images/replay-8bc7442ba89c75fd6d4062c3c8b52dfe.svg";